import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  AddEstimateSectionInput,
  AddEstimateSectionMutation as AddEstimateSectionMutationResult,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { hydrateEstimateCaches } from './hydrateEstimateCaches';

const AddEstimateSectionMutation = graphql(`
  mutation AddEstimateSection($input: AddEstimateSectionInput!) {
    addEstimateSection(input: $input) {
      ...EstimateBuilderEstimate
      preview {
        template
        context
        pendingSolarLayoutImage
      }
    }
  }
`);

type Variables = AddEstimateSectionInput & { publicId: string };

const useAddEstimateSection = (args: {
  projectId: string;
  estimateId: string;
  options?: UseMutationOptions<
    AddEstimateSectionMutationResult,
    Error,
    Variables
  >;
}) => {
  const { projectId, estimateId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation<AddEstimateSectionMutationResult, Error, Variables>({
    mutationFn: ({ estimateId: variableEstimateId, heading, publicId }) => {
      return gqlClient.request(AddEstimateSectionMutation, {
        input: { estimateId: variableEstimateId, heading, publicId },
      });
    },
    onSuccess: (data, variables, context) => {
      hydrateEstimateCaches(queryClient, {
        projectId,
        estimateId,
        estimate: data.addEstimateSection,
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useAddEstimateSection;
